import React from 'react';
import { Box, Checkbox } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { Trans } from 'react-i18next';

import { StyledSelectBenefitCard } from './BenefitTypeCard.styles';
import { useFormContext } from 'react-hook-form';
import {
  IBenefits,
  ICreateBenefitGroupForm
} from '@epi-models/pages/BenefitGroups';
import { BenefitTypeIcon } from '../BenefitTypeIcon/BenefitTypeIcon';

interface BenefitTypeCardProps {
  benefitType: IBenefits;
  maxAmount: number;
  disabled?: boolean;
}

export const BenefitTypeCard = ({
  benefitType,
  maxAmount,
  disabled
}: BenefitTypeCardProps) => {
  const { gray25, primaryBackColorLight, primaryBackLight } = useTheme();
  const { watch, setValue, formState, trigger } =
    useFormContext<ICreateBenefitGroupForm>();

  const value = watch(`benefitSettings.${benefitType}`);

  const handleToggleCheckbox = () => {
    if (disabled) {
      return null;
    }
    if (value) {
      setValue(`benefitSettings.${benefitType}`, undefined, {
        shouldDirty: true,
        shouldValidate: true
      });
    } else {
      const defaultValue =
        formState.defaultValues?.benefitSettings?.[benefitType];
      setValue(
        `benefitSettings.${benefitType}`,
        defaultValue || { maxAmountPerPeriod: maxAmount },
        { shouldDirty: true, shouldValidate: true }
      );
    }
    trigger();
  };

  return (
    <StyledSelectBenefitCard
      isSelected={!!value}
      onClick={handleToggleCheckbox}
      disabled={disabled}
    >
      <Box
        display="flex"
        alignItems="center"
        gap={1}
        color={disabled ? gray25 : primaryBackLight}
      >
        <Box
          width={32}
          height={32}
          display="flex"
          alignItems="center"
          justifyContent="center"
        >
          <BenefitTypeIcon
            benefit={benefitType?.toLowerCase()}
            color={disabled ? gray25 : primaryBackColorLight}
          />
        </Box>
        <Trans i18nKey={`containers.benefit_groups.benefits.${benefitType}`} />
      </Box>
      <Box>
        <Checkbox checked={!!value} disabled={disabled} />
      </Box>
    </StyledSelectBenefitCard>
  );
};
